export default "__VITE_ASSET__CLbVtO9g__"